"use client";

import { cn } from "@/lib/utils";
import useTranslate from "@app/_hooks/useTranslate";
import useAddToCart from "@features/cart/hooks/useAddToCart";
import { CartProduct } from "@features/product/utils/toCartProduct";
import { Button } from "@ui/button";
import { Loader2 } from "lucide-react";
import { ComponentProps } from "react";

export default function ProductCardCart({
  product,
  className,
  ...props
}: { product: CartProduct } & ComponentProps<typeof Button>) {
  const t = useTranslate();
  const { mutate, isPending } = useAddToCart();

  return (
    <Button
      disabled={isPending}
      onClick={() => mutate([product])}
      className={cn("w-full px-0", className)}
      {...props}
    >
      {isPending ? <Loader2 className="animate-spin" /> : t("addToCart")}
    </Button>
  );
}
